export default __webpack_public_path__ + "static/media/parentvideolanding.7d1670bf.png";